module.exports = __webpack_public_path__ + "static/media/Rectangle 407.6208a92e.png";